import produce, { Draft } from 'immer';
import { Company } from '../domain/company';
import { ElectronicBillingAction, ElectronicBillingDispatchObject } from './actions';

export interface ElectronicBillingState {
  title: string;
  companySelected: Company | null;
}

export const initialState: ElectronicBillingState = {
  title: 'Inventario',
  companySelected: null,
};

export const electronicBillingContextReducer = produce(
  (draft: Draft<ElectronicBillingState>, { type, payload }: ElectronicBillingDispatchObject<any>) => {
    switch (type) {
      case ElectronicBillingAction.ClearState:
        return initialState;

      case ElectronicBillingAction.CompanySelected:
        draft.companySelected = payload;
        break;

      default:
        throw new Error(`Unknown electronic action type: ${type}`);
    }
  },
);
